module.exports = __webpack_public_path__ + "static/media/btg.eaa023c0.webp";